<div class="main">
  <div class="printing">
    <spb-header/>
    <router-outlet/>
  </div>
  <div [style.flex]="1"></div>

  <div class="printing">
    <spb-footer
      (logoutUser)="configService.reset()"
      [license]="true"
      [token]="configService.accessToken()"
      [version]="version"
      copyrightYears="2020"
    />
  </div>
</div>